// Helpers para formatear datos del Phase 6 (replay/historial/colección).

export function formatChips(value, options = {}) {
  const { decimals = 0, prefix = "" } = options;
  if (value === null || value === undefined) return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return `${prefix}${new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n)}`;
}

export function formatProfit(value) {
  if (value === null || value === undefined) return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  const formatted = new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(n));
  if (n > 0) return `+${formatted}`;
  if (n < 0) return `-${formatted}`;
  return formatted;
}

export function profitTone(value) {
  if (value === null || value === undefined) return "neutral";
  const n = Number(value);
  if (Number.isNaN(n) || n === 0) return "neutral";
  return n > 0 ? "positive" : "negative";
}

export function formatEpochDate(epochSeconds) {
  if (!epochSeconds && epochSeconds !== 0) return "—";
  try {
    return new Intl.DateTimeFormat("es-AR", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(new Date(Number(epochSeconds) * 1000));
  } catch {
    return String(epochSeconds);
  }
}

export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined) return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return `${(n * 100).toFixed(decimals)}%`;
}

export function shortHandId(handId) {
  if (!handId) return "";
  // Format: 260506012627-7071540-0000161-1 → mostrar solo el seq al final
  const parts = String(handId).split("-");
  if (parts.length >= 3) return `#${parts[parts.length - 2]}`;
  return handId;
}

export function gameModeLabel(mode) {
  if (!mode) return "—";
  const m = String(mode).toUpperCase();
  const map = {
    NLH: "NLH",
    PLO: "PLO",
    PLO4: "PLO",
    PLO5: "PLO5",
    PLO6: "PLO6",
    HOLDEM: "NLH",
    OMAHA: "PLO",
  };
  return map[m] || m;
}

export function boardToString(board) {
  if (!board || !Array.isArray(board)) return "—";
  if (board.length === 0) return "—";
  return board.join(" ");
}
